import type { ReactNode } from 'react';
import styles from './list.module.css';

type ListProps = {
  children?: ReactNode;
  header?: string;
  intro?: ReactNode;
  footer?: string;
};

export const List = ({ children, header, intro, footer }: ListProps) => (
  <section className={styles.section}>
    {header !== undefined && <h2 className={styles.header}>{header}</h2>}
    {intro}
    {children !== undefined && <ul className={styles.list}>{children}</ul>}
    {footer !== undefined && <p className={styles.footer}>{footer}</p>}
  </section>
);
